import React, { Component } from 'react';
//import { NavLink } from 'react-router-dom'
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';

import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalFooter from 'react-bootstrap/ModalFooter';
import ModalTitle from 'react-bootstrap/ModalTitle';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ExcelRenderer } from 'react-excel-renderer';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Multiselect from 'react-widgets/lib/Multiselect'
import Checkbox from '@material-ui/core/Checkbox';
import $ from 'jquery';
import ReactExport from 'react-export-excel';
import { Button, Upload } from 'antd';
import Select from 'react-select';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
];

export default class Member extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            userid: user_id,
            user_permission: user_permission,
            pages: [],
            project_home: [],
            addIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            cancelIsOpen: false,
            updateIsOpen: false,
            content_id: ``,
            methodOpen: ``,
            jwt: jwt,
            add_id: ``,
            add_username: ``,
            add_password: ``,
            add_firstname: ``,
            add_lastname: ``,
            add_type: 'owner,install',
            old_types: ``,
            add_phone1: ``,
            add_email1: ``,
            add_project_home: ``,
            add_house: [],
            add_house_name: ``,
            add_residenceAll: ``,
            residence_id: '',
            residenceAllRm: [],
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            src_project: ``,
            src_idcard:``,
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, 'su'),
            spinner: true,
            spinnerres: true,
            add_residence: [],
            residenceAll: [],
            residenceNotAll: [],
            member_type: [],
            importIsOpen: false,
            rows: [],
            member_list: [],
            IsVerify: false,
            selectedOption: null,
            selectedOption__: null,
            inputValue: ``,
            IsIdCard: false,
            IsResidence: true,
            add_house_no: ""
        };

        $('#root').addClass('wrapper');
        $('body').removeClass('login-page');

        this.onKeyUp = this.onKeyUp.bind(this);

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.openCancel = this.openCancel.bind(this);
        this.closeCancel = this.closeCancel.bind(this);
        this.submitCancel = this.submitCancel.bind(this);

        this.onChange = this.onChange.bind(this);
        this.changeProjectName = this.changeProjectName.bind(this);
        this.changeProjectHome = this.changeProjectHome.bind(this)

        this.handleChangePage = this.handleChangePage.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.openImport = this.openImport.bind(this);
        this.closeImport = this.closeImport.bind(this);
        this.submitImport = this.submitImport.bind(this);
        this.submitVerify = this.submitVerify.bind(this);

        //this.residence(``)
        this.project_home()
        this.dataTable();
        //this.residenceAll()
        this.member_type()
    }

    IsNumeric(input) {
        var RE = /^-?(0|INF|(0[1-7][0-7]*)|(0x[0-9a-fA-F]+)|((0|[1-9][0-9]*|(?=[\.,]))([\.,][0-9]+)?([eE]-?\d+)?))$/;
        return (RE.test(input));
    }

    Script_checkID(id) {
        return true;

        if (!this.IsNumeric(id)) return false;
        if (id.substring(0, 1) == 0) return false;
        if (id.length != 13) return false;
        for (var i = 0, sum = 0; i < 12; i++)
            sum += parseFloat(id.charAt(i)) * (13 - i);
        if ((11 - sum % 11) % 10 != parseFloat(id.charAt(12))) return false;
    }

    checkID(id) {
        if (id != undefined) {
            var value = id
            if (value.length == 13 && value != ``) {
                value = value.replace(/-/g, ``);
                var result = this.Script_checkID(value);
                if (result === false) {
                    this.setState({ inputValue: `รหัสบัตรประจำตัวประชาชนผิด`, IsIdCard: false });
                    //$('span.error').removeClass('true').text('รหัสบัตรผิด');
                } else {
                    this.setState({ inputValue: `รหัสบัตรประจำตัวประชาชนถูกต้อง`, IsIdCard: true });
                    //$('span.error').addClass('true').text('รหัสบัตรถูกต้อง');
                }
            } else {
                this.setState({ inputValue: `รหัสบัตรประจำตัวประชาชนผิด`, IsIdCard: false });
            }
        }
    }

    onKeyUp(event) {
        var value = event.target.value
        if (value.length == 13 && value != ``) {
            value = value.replace(/-/g, ``);
            var result = this.Script_checkID(value);
            if (result === false) {
                this.setState({ inputValue: `รหัสบัตรประจำตัวประชาชนผิด`, IsIdCard: false });
                //$('span.error').removeClass('true').text('รหัสบัตรผิด');
            } else {
                this.setState({ inputValue: `รหัสบัตรประจำตัวประชาชนถูกต้อง`, IsIdCard: true });
                //$('span.error').addClass('true').text('รหัสบัตรถูกต้อง');
            }
        } else {
            this.setState({ inputValue: ``, IsIdCard: false });
        }
    }

    project_home() {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: ``, display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            } else {
                fetch(config.url.API_URL + '/project_homes/', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: ``, display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    residenceAll(project_home_id) {
        try {
            this.state.PROJECTID = project_home_id
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/residencesByProjectHome/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data_res => {
    
                        let FromApi = data_res.data.residence.map(data => {
                            return { value: data.id, display: data.house_no }
                        });
                        this.setState({
                            IsResidence: false,
                            residenceAll: [{ value: ``, display: 'เลือกบ้านเลขที่' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        // //window.location.reload(); // Reload the page
                    });
            } else {
                fetch(config.url.API_URL + '/residencesSrc', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        //alert(data.status);
                        let FromApi = data.data.map(data => {
                            return { value: data.id, display: `${data.house_no}(${data.project_name})` }
                        });
                        this.setState({
                            residenceAll: [{ value: ``, display: 'เลือกบ้านเลขที่' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        // //window.location.reload(); // Reload the page
                    });
            }
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    member_type() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/permissionMemberType', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    var found = data.data.filter(function (item) { return (item.type_name == 'owner' || item.type_name == 'install'); });
                    let FromApi = found.map(data => {
                        return { value: data.type_name, display: data.name }
                    });
                    this.setState({
                        member_type: [{ value: ``, display: 'เลือกประเภท' }].concat(FromApi)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    residence(project_home_id) {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (project_home_id) {
                body = `?projecthomeid=${project_home_id}`
            }else{
                body = `?projecthomeid=`
            }
    
            body += '&active=true'
            fetch(config.url.API_URL + '/residencesByProjectHome2/' + body, requestOptions)
                .then(res => res.json())
                .then(data_res => {
                    var data = data_res.data;
                    console.log(`data_res`, data)
                    let FromApi = data_res.data.residence.map(data => {
                        console.log(`in map`, data)
                        return { value: data.id, label: data.house_no }
                    });
                    console.log(`res not all`,this.state.residenceNotAll)
                    console.log(`res FromApi`,FromApi)
                    this.setState({
                        residenceNotAll: FromApi,
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
            return true
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    dataTable() {
        try {
            let project_id = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                project_id = this.state.PROJECTID
            } else {
                project_id = ``
            }
    
            //let body = `?user_type=owner,install`
            let body = `?user_type=owner,install&projecthomeid=${project_id}`
            fetch(config.url.API_URL + '/members/' + body, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data
                    this.setState({
                        // pages: [].concat(data),
                        pages: [].concat(data),
                        spinner: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTableSrc() {
        try {
            let project_id = ``
            this.setState({
                spinner: true
            });
    
            if (this.state.PROJECTID) {
                project_id = this.state.PROJECTID
            } else {
                project_id = ``
            }
    
            if (this.state.src_project) {
                project_id = this.state.src_project
            } else {
                project_id = ``
            }
    
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            
            let body = `?user_type=${this.state.add_type}&active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&username=${this.state.add_username}&firstname=${this.state.add_firstname}&residenceid=${this.state.add_residenceAll}&house_no=${this.state.add_house_no}&phone=${this.state.add_phone1}&projecthomeid=${project_id}&idcard=${this.state.src_idcard}`
    
            fetch(config.url.API_URL + '/members/' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data),
                            spinner: false
                        });
    
                    } else {
                        this.setState({
                            pages: [],
                            spinner: false
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_id: ``,
            add_username: ``,
            add_password: ``,
            add_firstname: ``,
            add_lastname: ``,
            add_type: ``,
            add_phone1: ``,
            add_email1: ``,
            add_project_home: ``,
            inputValue: ``,
            add_idcard: ``,
            add_house: [],
            add_residence: [],
            selectedOption: null,
            selectedOption__: null
        });
    }

    async openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            const response = await fetch(config.url.API_URL + '/members/' + e.currentTarget.attributes['data-id'].value, requestOptions);
            if(response.status == 200){
                const json = await response.json();
                var data = json.data;
                var residence = json.residence;
                const json2 = await this.residence(data.project_home_id)
                if (json2) {
                    this.setState({
                        add_id: data.id,
                        add_username: data.username,
                        add_type: data.type,
                        old_types: data.type,
                        add_firstname: data.firstname,
                        add_lastname: data.lastname,
                        add_phone1: data.phone1,
                        add_email1: data.email1,
                        add_project_home: data.project_home_id,
                        add_house: data.residence_house,
                        add_residence: residence,
                        selectedOption: residence,
                        selectedOption__: residence,
                        active: data.active,
                        addIsOpen: true,
                        add_idcard: data.idcard,
                        add_oldidcard: data.idcard,
                        methodOpen: 'edit'
                    });
                    this.checkID(data.idcard)
                }
            }else{
                //window.location.reload(); // Reload the page
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            //let body = `?menu=member&updateby=${this.state.create_by}&updateby_id=${this.state.create_by_id}`
    
            fetch(config.url.API_URL + '/members/' + e.currentTarget.attributes['data-id'].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data.id,
                        add_username: data.username,
                        add_type: data.type,
                        add_firstname: data.firstname,
                        add_lastname: data.lastname,
                        add_phone1: data.phone1,
                        add_email1: data.email1,
                        add_active_status: data.active_status,
                        add_house_name: data.house,
                        add_idcard: data.idcard,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    })
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeCancel(){
        this.setState({ cancelIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: ``,
            add_name: ``,
            add_name_en: ``,
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({
            IsResidence: true,
            srcIsOpen: false
        });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_idcard: ``,
            src_active: false,
            src_nonactive: false,
            add_username: ``,
            add_type: 'owner,install',
            add_firstname: ``,
            add_phone1: ``,
            add_residenceAll: ``,
            page: 0,
            residenceAll: [],
            src_project: ``,
            add_house_no: ""
        });
    }

    submitAdd() {
        try {
            var phone = [];
            var email = [];
    
            if (!this.state.add_username) {
                alert('ไม่พบข้อมูลชื่อใช้ระบบ');
                return;
            }
    
            if (!this.state.add_firstname) {
                alert('ไม่พบข้อมูลชื่อ');
                return;
            }
    
            if (!this.state.add_lastname) {
                alert('ไม่พบข้อมูลนามสกุล');
                return;
            }
    
            if (!this.state.add_type) {
                alert('ไม่พบข้อมูลประเภทผู้ใช้');
                return;
            }
    
            if (!this.state.add_phone1) {
                alert('ไม่พบข้อมูลเบอร์มือถือ');
                return;
            }
    
            if (!this.state.add_email1) {
                alert('ไม่พบข้อมูลอีเมล');
                return;
            }
    
            if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.add_email1)){
                alert('อีเมลไม่ถูกต้อง');
                return;
            }
    
            if (!this.state.add_idcard) {
                alert('ไม่พบข้อมูลรหัสบัตรประจำตัวประชาชน');
                return;
            }
    
            if (!this.state.add_project_home) {
                alert('ไม่พบข้อมูลโครงการ');
                return;
            }
    
            if (!this.state.IsIdCard) {
                alert('รหัสบัตรประจำตัวประชาชนผิด');
                return;
            }
    
            if (!this.state.add_house) {
                alert('ไม่พบข้อมูลบ้านเลขที่');
                return;
            }
    
            if(this.state.add_residence.length == 0){
                alert('ไม่พบข้อมูลเจ้าของบ้าน');
                return;
            }
    
            if (this.state.add_phone1) {
                phone.unshift({ phone: this.state.add_phone1 })
            }
    
            if (this.state.add_email1) {
                email.unshift({ email: this.state.add_email1 })
            }
    
            //console.log(jwt);
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    username: this.state.add_username,
                    password: this.state.add_password,
                    firstname: this.state.add_firstname,
                    lastname: this.state.add_lastname,
                    idcard: this.state.add_idcard,
                    phone: phone,
                    email: email,
                    active_status: this.state.active ? 1 : 0,
                    user_types: this.state.add_type,
                    old_types: this.state.old_types,
                    user_type: [{ user_type: this.state.add_type }],
                    residence_id: this.state.add_residence,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id,
                    menu: 'ลูกบ้าน / รอโอน'
                }),
            };
    
            fetch(config.url.API_URL + '/members', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if(data.status == 'Success'){
                        this.setState({
                            updateIsOpen: true,
                            spinner: true
                        });
                    }else{
                        alert(data.message)
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitCancel(e) {
        try {
            if(!this.state.residence_id){
                alert('ไม่พบข้อมูลบ้านเลขที่');
                return;
            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    residence_id: this.state.residence_id,
                    member_id: this.state.content_id,
                    member_firstname: '',
                    member_lastname: '',
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id,
                    menu: 'ลูกบ้าน / รอโอน'
                }),
            };
        
        // content_id -> member_id
        fetch(config.url.API_URL + '/cancelmember/' + this.state.content_id, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({
                    updateIsOpen: true,
                    spinner: true
                });
                this.dataTable()
            }).catch(error => {
                console.log(error)
                //window.location.reload(); // Reload the page
            })
    
        this.setState({ cancelIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id,
                    menu: 'ลูกบ้าน / รอโอน'
                }),
            };
    
    
            fetch(config.url.API_URL + '/deletemember/' + this.state.add_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        spinner: true
                    });
                    this.dataTable()
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    async openCancel(e){
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            this.setState({
                content_id: e.currentTarget.attributes['data-id'].value,
            })
            const response = await fetch(config.url.API_URL + '/members/' + e.currentTarget.attributes['data-id'].value, requestOptions);
            if(response.status == 200){
                const json = await response.json();
                console.log(json.residence)
                this.setState({
                    residenceAllRm: json.residence,
                    cancelIsOpen: true,
                });
            }else{
                //window.location.reload();
            }

        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            add_id: e.currentTarget.attributes['data-id'].value
        });
    }

    submitEdit(e) {
        try {
            if (!this.state.add_username) {
                alert('ไม่พบข้อมูลชื่อใช้ระบบ');
                return;
            }
    
            if (!this.state.add_firstname) {
                alert('ไม่พบข้อมูลชื่อ');
                return;
            }
    
            if (!this.state.add_lastname) {
                alert('ไม่พบข้อมูลนามสกุล');
                return;
            }
    
            if (!this.state.add_type) {
                alert('ไม่พบข้อมูลประเภทผู้ใช้');
                return;
            }
    
            if (!this.state.add_phone1) {
                alert('ไม่พบข้อมูลเบอร์มือถือ');
                return;
            }
    
            if (!this.state.add_email1) {
                alert('ไม่พบข้อมูลอีเมล');
                return;
            }
    
            if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.add_email1)){
                alert('อีเมลไม่ถูกต้อง');
                return;
            }
    
            if (!this.state.add_idcard) {
                alert('ไม่พบข้อมูลรหัสบัตรประจำตัวประชาชน');
                return;
            }
    
            if (!this.state.add_project_home) {
                alert('ไม่พบข้อมูลโครงการ');
                return;
            }
    
            if (!this.state.IsIdCard) {
                alert('รหัสบัตรประจำตัวประชาชนผิด');
                return;
            }
    
            if (!this.state.add_house) {
                alert('ไม่พบข้อมูลบ้านเลขที่');
                return;
            }
    
            if(this.state.add_residence.length == 0){
                alert('ไม่พบข้อมูลเจ้าของบ้าน');
                return;
            }
    
            var phone = [];
            var email = [];
    
            if (this.state.add_phone1) {
                phone.unshift({ phone: this.state.add_phone1 })
            }
    
            if (this.state.add_email1) {
                email.unshift({ email: this.state.add_email1 })
            }
    
            //console.log(jwt);
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    userId: this.state.add_id,
                    username: this.state.add_username,
                    password: this.state.add_password,
                    firstname: this.state.add_firstname,
                    lastname: this.state.add_lastname,
                    idcard: this.state.add_idcard,
                    phone: phone,
                    email: email,
                    user_types: this.state.add_type,
                    old_types: this.state.old_types,
                    user_type: [{ user_type: this.state.add_type }],
                    residence_id: this.state.selectedOption,
                    residence_old_id: this.state.selectedOption__,
                    active_status: this.state.active ? 1 : 0,
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id,
                    menu: 'ลูกบ้าน / รอโอน'
                }),
            };
    
            fetch(config.url.API_URL + '/members/' + e.currentTarget.attributes['data-id'].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    console.log(`update data`)
                    console.log(data)
                    this.setState({
                        updateIsOpen: true,
                        spinner: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openImport() {
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false
        });
    }

    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    submitImport() {
        try {
            if (this.state.rows.length < 1) {
                alert('ไม่มีข้อมูลการ import')
                return
            }
    
            if (!this.state.IsVerify) {
                alert('กรุณาตรวจสอบข้อมูล')
                return
            }
    
            this.setState({
                importIsOpen: false,
                spinner: true
            });
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    import_data: this.state.rows,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
    
                })
            };
    
            fetch(config.url.API_URL + '/import_members', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        //importIsOpen: false,
                        updateIsOpen: true,
                        spinner: false
                    });
                }).catch(err => {
                    console.log(`error durring import  member`)
                    console.log(err)
                    this.setState({
                        spinner: false,
                        updateIsOpen: false
                    })
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    changeProjectName(e) {
        this.setState({
            [e.target.name]: e.target.value,
            residenceAll: [],
            residenceNotAll: []
        });
        this.residence(e.target.value)
        this.residenceAll(e.target.value)
    }

    changeProjectHome(e) {
        this.residence(e.target.value)
        this.setState({add_project_home: e.target.value})
    }

    fileHandler2 = fileList => {
        console.log('fileList', fileList);
        let fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: 'No file uploaded!'
            });
            return false;
        }
        console.log('fileObj.type:', fileObj.type);
        if (
            !(
                fileObj.type === 'application/vnd.ms-excel' ||
                fileObj.type ===
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
        ) {
            this.setState({
                errorMessage: 'Unknown file format. Only Excel files are uploaded!'
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                let newRows = [];
                resp.rows.slice(1).map((row, index) => {
                    if (row.length > 0) {
                        newRows.push({
                            key: index,
                            no: row[0],
                            project_name: row[1],
                            houseNo: row[2],
                            plot: row[3],
                            member_type: helpers.getMemberType2(row[4]),
                            member_types: row[4],
                            firstname: row[8],
                            lastname: row[9],
                            phone1: row[11],
                            phone2: row[12],
                            phone3: row[13],
                            email1: row[14],
                            email2: row[15],
                            email3: row[16],
                            username: row[17] == undefined ? `` : row[17],
                            password: row[18] == undefined ? `` : row[18],
                        });
                    }
                }, {});
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: 'No data found in file!'
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });
                }
            }
        });
        return false;
    };

    submitVerify() {
        try {
            if (this.state.rows.length < 1) {
                alert('ไม่มีข้อมูลการ import')
                return
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    import_data: this.state.rows,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
    
                })
            };
    
            fetch(config.url.API_URL + '/verify_import_members', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var dataArr = data.data
                    if (dataArr) {
                        alert('ตรวจสอบเรียบร้อย')
                        if (data.message == 'Error') {
                            document.getElementById('submitImport').disabled = true
                            this.setState({
                                rows: dataArr,
                                errorMessage: null,
                                IsVerify: false
                            });
                        } else {
                            document.getElementById('submitImport').disabled = false
                            this.setState({
                                rows: dataArr,
                                errorMessage: null,
                                IsVerify: true
                            });
                        }
                    }
                }).catch(err => {
                    console.log(`error durring verify import member`)
                    console.log(err)
                    this.setState({
                        rows: [],
                        errorMessage: 'error cannot import member',
                        IsVerify: false
                    });
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    handleChange = (selectedOption) => {
        this.setState(
            { selectedOption },
            () => console.log(`Option selected:`, this.state.selectedOption)
        );

        let resArr = []
        if(selectedOption != null){
            this.setState({add_residence:[]})
            selectedOption.map(result => {
                resArr.push({id:result.value})
            })
            this.setState({add_residence:resArr})
        }else{
            this.setState({add_residence:[]})
        }
    };

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: '#E8EFF5',
                color: '#212529',
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);
        const { selectedOption } = this.state;

        return (
            <div className='content-wrapper'>
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h1 className='m-0 text-dark'>Member List</h1>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><a href='/'>Home</a></li>
                                    <li className='breadcrumb-item active'>Member</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className='content'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='card'>
                                <div className='card-header'>
                                    <div className='btn-advance text-center' onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename='Members' element={(this.state.user_permission[214].permission == 1 &&
                                        <div className='btn-add text-center'>Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name='members'>
                                            <ExcelColumn label='ชื่อใช้ระบบ' value='username' />
                                            <ExcelColumn label='ประเภทผู้ใช้' value={(col) => helpers.getMemberType(col.user_type)} />
                                            <ExcelColumn label='ชื่อ-นามสกุล' value='member_name' />
                                            <ExcelColumn label='รหัสบัตรประจำตัวประชาชน' value='idcard' />
                                            <ExcelColumn label='เบอร์โทรศัพท์' value={(col) => col.phone} />
                                            <ExcelColumn label='เจ้าของบ้านเลขที่' value={(col) => col.owner_home} />
                                            <ExcelColumn label='อัพเดทล่าสุด' value={(col) => col.updateby} />
                                            <ExcelColumn label='อัพเดทล่าสุด(เวลา)' value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {(this.state.user_permission[4].permission == 1 &&
                                        <div className='btn-add text-center' onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                    {/* {(this.state.user_permission[215].permission == 1 &&
                                        // <div className='btn-add text-center' ><a href={'https://admin.nvdsmarthome.com/downloadFile/template_member.xlsx'} style={{ color: 'black' }}>Download Template</a></div>
                                        <div className='btn-add text-center' ><a href={`${config.url.API_URL}/downloadFile/template_member.xlsx`} style={{ color: 'black' }}>Download Template</a></div>
                                    )} */}
                                    {/* {(this.state.user_permission[213].permission == 1 &&
                                        <div className='btn-add text-center' onClick={this.openImport}>Import</div>
                                    )} */}
                                </div>
                                {/* .card-header */}
                                <div className='card-body'>
                                    {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                            <Table aria-label='simple table'>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ชื่อใช้ระบบ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ประเภทผู้ใช้</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>ชื่อ-นามสกุล</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>รหัสบัตรประจำตัวประชาชน</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>เจ้าของบ้านเลขที่</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                        <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                                return (
                                                                    <StyledTableRow key={`1${i}`}>
                                                                        <StyledTableCell>{data.num}</StyledTableCell>
                                                                        <StyledTableCell>{data.username}</StyledTableCell>
                                                                        <StyledTableCell>{helpers.getMemberType(data.user_type)}</StyledTableCell>
                                                                        <StyledTableCell>{data.member_name}</StyledTableCell>
                                                                        <StyledTableCell>{data.phone}</StyledTableCell>
                                                                        <StyledTableCell>{data.idcard ? data.idcard.substring(0, 3) + "XXXXXXX" + data.idcard.substring(10, 13) : ''}</StyledTableCell>
                                                                        <StyledTableCell>{data.owner_home}</StyledTableCell>
                                                                        <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                        {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                        {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                        <StyledTableCell>
                                                                            <button className='btn-action text-center' data-id={data.id} onClick={this.openView}><img src='dist/img/icon/ic_view.png' className='btn-icon' alt='' />View</button>
                                                                            {(this.state.user_permission[5].permission == 1 &&
                                                                                <button className='btn-action text-center' data-id={data.id} onClick={this.openEdit}><img src='dist/img/icon/ic_update.png' className='btn-icon' alt='' /> Update</button>
                                                                            )}
                                                                            {(this.state.user_permission[6].permission == 1 && data.owner_home != '' &&
                                                                                <button className='btn-action text-center' data-id={data.id} onClick={this.openCancel}>ยกเลิกเจ้าบ้าน</button>
                                                                            )}
                                                                            {(this.state.user_permission[6].permission == 1 &&
                                                                                <button className='btn-action text-center' data-id={data.id} onClick={this.openDelete}><img src='dist/img/icon/ic_del.png' className='btn-icon' alt='' /> Delete</button>
                                                                            )}
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>)
                                                            })
                                                    }
                                                    {emptyRows > 0 && (
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={6} />
                                                        </StyledTableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 25, 50, 75, 100, 500]}
                                                component='div'
                                                count={this.state.pages.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    }
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size='lg'>
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id='form-serach'>
                            <div className='row mb-3 align-center' >
                                <div className='col-sm-3 text-right'>Username</div>
                                <div className='col-sm-5'>
                                    <input type='text' className='form-control' id='add_username' name='add_username' onChange={this.change} />
                                </div>
                            </div>
                            <div className='row mb-3 align-center'>
                                <div className='col-sm-3 text-right'>ชื่อ</div>
                                <div className='col-sm-5'>
                                    <input type='text' className='form-control' id='add_firstname' name='add_firstname' onChange={this.change} />
                                </div>
                            </div>
                            <div className='row mb-3 align-center'>
                                <div className='col-sm-3 text-right'>รหัสบัตรประจำตัวประชาชน</div>
                                <div className='col-sm-5'>
                                    <input type='text' className='form-control' id='src_idcard' name='src_idcard' onChange={this.change} />
                                </div>
                            </div>
                            <div className='row mb-3 align-center'>
                                <div className='col-sm-3 text-right'>โครงการ :</div>
                                <div className='col-sm-5'>
                                    <select className='form-control' id='src_project' name='src_project' style={{ height: 45 }} onChange={this.changeProjectName}>
                                        {this.state.project_home.map((datas, i) => <option key={i} value={datas.value}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className='row mb-3 align-center'>
                                <div className='col-sm-3 text-right' >บ้านเลขที่</div>
                                <div className='col-sm-5'>
                                    {!this.state.IsResidence ? <select className='form-control' name='add_residenceAll' onChange={this.change}>
                                        {this.state.residenceAll.map((data, i) => <option key={i} value={data.value}>{data.display}</option>)}
                                    </select> : <input type='text' className='form-control' id='add_house_no' name='add_house_no' onChange={this.change} />}
                                </div>
                            </div>
                            <div className='row mb-3 align-center'>
                                <div className='col-sm-3 text-right'>เบอร์โทรศัพท์</div>
                                <div className='col-sm-5'>
                                    <input type='text' className='form-control' id='add_phone1' name='add_phone1' defaultValue={this.state.add_phone1} onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>ประเภทผู้ใช้ :</div>
                                <div className='col-sm-5'>
                                    <select className='form-control' name='add_type' onChange={this.change}>
                                        <option value='0'>เลือกประเภทผู้ใช้</option>
                                        <option value='owner' selected={this.state.add_type === 'owner' && 'selected'}>เจ้าของบ้านโอนแล้ว</option>
                                        <option value='install' selected={this.state.add_type === 'install' && 'selected'}>เจ้าของบ้านติดโอน</option>
                                    </select>
                                </div>
                            </div> */}
                            <div className='row mb-3 align-center'>
                                <div className='col-sm-3 text-right' >ประเภทผู้ใช้</div>
                                <div className='col-sm-5'>
                                    <select className='form-control' name='add_type' onChange={this.change}>
                                        {this.state.member_type.map((data, i) => <option key={i} value={`${data.value}`} selected={this.state.add_type === data.value && 'selected'}>{data.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className='row mb-3 align-center' >
                                <div className='col-sm-3 text-right'>สถานะ</div>
                                <div className='col-sm-5'>
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color='primary'
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color='primary'
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-danger' onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className='btn btn-success' onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size='xl'>
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && 'เพิ่มข้อมูล') || (this.state.methodOpen === 'edit' && 'แก้ไขข้อมูล') || (this.state.methodOpen === 'view' && 'ตรวจสอบข้อมูล')}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id='form-submit'>
                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>Username<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type='text' className='form-control' id='add_username' name='add_username' defaultValue={this.state.add_username} onChange={this.change} />)
                                        : (<div className='form-control'>{this.state.add_username}</div>)}
                                </div>
                            </div>

                            {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ? (
                                <div className='row mb-3'>
                                    <div className='col-sm-3 text-right'>Password<span style={{ color: 'red' }}>*</span></div>
                                    <div className='col-sm-5'>
                                        <input type='password' className='form-control' id='add_password' name='add_password' defaultValue='' onChange={this.change} />
                                    </div>
                                </div>) : ``}

                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>ชื่อ<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type='text' className='form-control' id='add_firstname' name='add_firstname' defaultValue={this.state.add_firstname} onChange={this.change} />)
                                        : (<div className='form-control'>{this.state.add_firstname}</div>)}
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>นามสกุล<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type='text' className='form-control' id='add_lastname' name='add_lastname' defaultValue={this.state.add_lastname} onChange={this.change} />)
                                        : (<div className='form-control'>{this.state.add_lastname}</div>)}
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>ประเภทผู้ใช้<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className='form-control' name='add_type' onChange={this.change}>
                                            {this.state.member_type.map((data, i) => <option key={i} value={`${data.value}`} selected={this.state.add_type === data.value && 'selected'}>{data.display}</option>)}
                                        </select>)
                                        : (<div className='form-control'>{helpers.getMemberType(this.state.add_type)}</div>)}
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>เบอร์โทรศัพท์<span style={{ color: 'red' }}>*</span></div>
                                {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ? (
                                    <div className='col-sm-5'>
                                        <input type='text' className='form-control' id='add_phone1' name='add_phone1' defaultValue={this.state.add_phone1} onChange={this.change} />
                                    </div>)
                                    : (<div className='col-sm-5'><div className='form-control'>{this.state.add_phone1}</div></div>)}
                            </div>
                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>รหัสบัตรประจำตัวประชาชน<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        <input type='text' className='form-control' id='add_idcard' name='add_idcard' defaultValue={this.state.add_idcard} onChange={this.change} maxLength={13} onKeyUp={this.onKeyUp} />
                                        : (<div className='form-control'>{this.state.add_idcard}</div>)}<div>{this.state.inputValue}</div>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>อีเมล<span style={{ color: 'red' }}>*</span></div>
                                {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ? (
                                    <div className='col-sm-5'>
                                        <input type='text' className='form-control' id='add_email1' name='add_email1' defaultValue={this.state.add_email1} onChange={this.change} />
                                    </div>)
                                    : (<div className='col-sm-5'><div className='form-control'>{this.state.add_email1}</div></div>)}
                            </div>

                            {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                (<div className='row mb-3'>
                                    <div className='col-sm-3 text-right' >โครงการ<span style={{ color: 'red' }}>*</span></div>
                                    <div className='col-sm-5'>
                                        <select className='form-control' name='add_project_home' onChange={this.changeProjectHome}>
                                            {this.state.project_home.map((data, i) => <option key={i} value={data.value} selected={this.state.add_project_home === data.value && 'selected'}>{data.display}</option>)}
                                        </select>
                                    </div>
                                </div>) : ``}

                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>เจ้าของบ้าน<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<Select
                                            value={selectedOption}
                                            onChange={this.handleChange}
                                            options={this.state.residenceNotAll}
                                            isMulti
                                            isSearchable
                                        />)
                                        : (<TextareaAutosize className='form-control' name='add_house_name' rowsMin={1} defaultValue={this.state.add_house_name} disabled />)
                                    }
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color='primary'
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>

                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className='btn btn-danger' onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className='btn btn-success' onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className='btn btn-danger' onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className='btn btn-warning' data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className='btn btn-success' onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size='s'>
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-success' onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size='s'>
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-danger' onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className='btn btn-warning' onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.cancelIsOpen} onHide={this.closeCancel} size='s'>
                    <ModalHeader>
                        <ModalTitle>ยืนยันการยกเลิกรายการเจ้าบ้านใช่หรือไม่</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <div className='row mb-3'>
                                <div className='col-sm-3 text-right'>ยกเลิกบ้านเลขที่<span style={{ color: 'red' }}>*</span></div>
                                <div className='col-sm-5'>
                                    <select className='form-control' name='residence_id' id='residence_id' onChange={this.change}>
                                        <option value="">เลือกบ้านเลขที่</option>
                                        {
                                            this.state.residenceAllRm.map(data => 
                                                <option value={data.value}>{data.label}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className='btn btn-danger' onClick={this.closeCancel}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className='btn btn-warning' onClick={this.submitCancel}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size='xl'>
                    <ModalHeader>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <Upload name='file' beforeUpload={this.fileHandler2} onRemove={() => this.setState({ rows: [] })} multiple={false} accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' >
                                    <Button className='btn btn-primary'> Import Excel File </Button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id='form-submit'>
                            <div className='row mb-3'>
                                <div className='col-sm-12'>
                                    <TableContainer component={Paper}>
                                        <Table aria-label='simple table'>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>ลำดับ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>แปลง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ประเภทผู้ใช้</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>นามสกุล</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์2</StyledTableCell> */}
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์3</StyledTableCell> */}
                                                    <StyledTableCell style={{ width: 'auto' }}>อีเมล</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>อีเมล2</StyledTableCell> */}
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>อีเมล3</StyledTableCell> */}
                                                    <StyledTableCell style={{ width: 'auto' }}>username</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>password</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{data.no}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.houseNo}</StyledTableCell>
                                                                    <StyledTableCell>{data.plot}</StyledTableCell>
                                                                    <StyledTableCell>{data.member_types}</StyledTableCell>
                                                                    <StyledTableCell>{data.firstname}</StyledTableCell>
                                                                    <StyledTableCell>{data.lastname}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone1}</StyledTableCell>
                                                                    {/* <StyledTableCell>{data.phone2}</StyledTableCell> */}
                                                                    {/* <StyledTableCell>{data.phone3}</StyledTableCell> */}
                                                                    <StyledTableCell>{data.email1}</StyledTableCell>
                                                                    {/* <StyledTableCell>{data.email2}</StyledTableCell> */}
                                                                    {/* <StyledTableCell>{data.email3}</StyledTableCell> */}
                                                                    <StyledTableCell>{data.username}</StyledTableCell>
                                                                    <StyledTableCell>{data.password}</StyledTableCell>
                                                                    <StyledTableCell>{data.comment}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component='div'
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <button className='btn btn-warning' onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className='btn btn-danger' onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button id='submitImport' className='btn btn-success' data-id={this.state.add_id} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}